import { useTranslation } from 'react-i18next';
import version from '../package.json';
import { PLUGIN_NAME, DEFAULT_LANGUAGE } from './constants';
import init from './utils/init';
import loadTranslations from './utils/load-translations';
function load(app, options = {}) {
  const {
    primaryLanguage: primaryLanguageOption
  } = options;
  const primaryLanguage = process.env.BLAZE_TRANSLATION_LANGUAGE || primaryLanguageOption || DEFAULT_LANGUAGE;
  let translation;
  const translationPromise = init({
    primaryLanguage
  });
  app.events.once(`plugin:${PLUGIN_NAME}:load:loaded`, async () => {
    translation = await translationPromise;
    const eventFn = (translations, namespace) => {
      loadTranslations(translation, translations, primaryLanguage, namespace);
    };
    await app.events.emitAsync(`plugin:${PLUGIN_NAME}:translations:load`, eventFn);
    await app.events.emitAsync(`plugin:${PLUGIN_NAME}:translations:override`, eventFn);
  });
  return {
    name: PLUGIN_NAME,
    version,
    translation
  };
}
load.pluginName = PLUGIN_NAME;
export { useTranslation };
export default load;
//# sourceMappingURL=index.js.map